"use client";

import { useEffect } from "react";

const REST_MS = 3000;
const FADE_MS = 900;

/**
 * Lets the decoration rest while someone reads: after REST_MS without
 * scrolling, <html data-motion="fading"> fades the petals out, and once the
 * fade is over data-motion="rest" pauses them (globals.css). The next scroll
 * removes the attribute and they come back where they stopped.
 *
 * Why: while any animation runs, Chrome recomputes the page in every frame as
 * long as something watches elements coming into view (lazy images, petals,
 * sections). Operator's choice 18.10.2026 (option B of the design review).
 */
export function MotionRest() {
  useEffect(() => {
    const root = document.documentElement;
    let restTimer = 0;
    let fadeTimer = 0;

    const arm = () => {
      window.clearTimeout(restTimer);
      window.clearTimeout(fadeTimer);
      restTimer = window.setTimeout(() => {
        root.dataset.motion = "fading";
        fadeTimer = window.setTimeout(() => {
          root.dataset.motion = "rest";
        }, FADE_MS);
      }, REST_MS);
    };
    const onScroll = () => {
      if (root.dataset.motion) delete root.dataset.motion;
      arm();
    };

    arm();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => {
      window.removeEventListener("scroll", onScroll);
      window.clearTimeout(restTimer);
      window.clearTimeout(fadeTimer);
      delete root.dataset.motion;
    };
  }, []);

  return null;
}
